import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { User } from '../_models';
import { RootService } from './root.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  BaseURI: string;

  constructor(private http: HttpClient, private rootService: RootService) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
    this.BaseURI = this.rootService.GetBaseURL();
  }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(username: string, password: string) {
    const param = {
      UserName: username,
      Password: password,
    };
    // console.log('console')
    return this.http
      .post<any>(this.BaseURI + '/Auth/login', param, this.httpOptions)
      .pipe(
        map((user) => {
          if (user && user['accessToken']) {
            // store user details and access token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(user);
          }
          return user;
        })
      );
  }
  getJwtToken() {
    return this.currentUserValue.accessToken;
  }
  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    return true;
  }
  reset() {
    const param = {
      Email: 'Agadia@ilink-systems.com',
    };
    return this.http.post<any>(
      this.BaseURI + '/Auth/ForgetPassword',
      param,
      this.httpOptions
    );
  }
}
